import styled from "styled-components";

interface Props {
  active?: boolean;
  size?: number;
}

export const MarkerElement = styled.div<Props>`
  background-color: ${(p) =>
    p.active
      ? "var(--ant-primary-color)"
      : "var(--ant-primary-color-disabled)"};
  width: ${s}px;
  height: ${s}px;
  display: block;
  /* left: ${left}px; */
  top: ${top}px;
  position: relative;
  border-radius: ${s}px ${s}px 0;
  transform: rotate(45deg);
  transform-origin: center;
  border: 1px solid var(--ant-primary-color);
`;

function s(p: Props) {
  return p.size || 30;
}

function left(p: Props) {
  return (p.size || 30) * 0.5;
}

function top(p: Props) {
  const size = p.size || 30;
  return Math.hypot(size, size) * -0.5;
}
